import {apiPost, API_URL} from '../api'
import {ApiRes} from '../../types/api'

interface IEditPost {
    id: string
    title: string
    content: string
    channel: string
    visibility: number
    images: string[]
    type?: string
    categories?: string[]
    thumbnail?: string
    important_at?: number
}

interface IProp {
    success?: true
}

export const postEditPost = async (edit_data: IEditPost): Promise<ApiRes<IProp>> => {
    return await apiPost(API_URL, 'admin/post_edit', edit_data)
}
